export default __webpack_public_path__ + "static/media/fair.c22af328.png";